export default __webpack_public_path__ + "static/media/275ff47e-d2f9-49b7-86b1-ef57c4bec3ae.df686a1b.JPG";